export default __webpack_public_path__ + "320883fcd012d7f2696c9bdab0bf3611.svg";